import { render, staticRenderFns } from "./SelectResultBet.vue?vue&type=template&id=6af22b53"
import script from "./SelectResultBet.vue?vue&type=script&lang=js"
export * from "./SelectResultBet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports